<template>
  <div id="app">
    <page-header/>
    <router-view></router-view>
    <page-footer/>
  </div>
</template>

<script>
import PageHeader from './pages/PageHeader'
import PageFooter from './pages/PageFooter'

export default {
  name: 'app',
  components: {
    PageHeader,
    PageFooter
  }
}
</script>

<style lang='scss'>

</style>



// WEBPACK FOOTER //
// App.vue?7fee6c79